import { ProductCard } from './ProductCard';

export { ProductCard } from './ProductCard';
export const ProductEntry = ProductCard;
